<script>
/* COMPOSANTS */

import accommodationService from '@services/accommodationService';
import AkAccommodationResume from '@components/v2/general/AkAccommodationResume.vue';
import GaListView from '@components/v2/layout/GaListView.vue';
import GaView from '@components/v2/layout/GaView.vue';
import loaderMixin from '@mixins/loaderMixin';
import messageMixin from '@mixins/messageMixin';
import AkLoader from '../../../components/general/AkLoader.vue';
import AkButtonAction from '@components/v2/general/AkButtonAction.vue';
import GaLayoutEmptyTab from '@components/v2/general/GaLayoutEmptyTab.vue';
import mainTabMixin from '@mixins/mainTabMixin';
import permissionsMixinComputed from '@mixins/permissionsMixinComputed';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';

export default {
  components: {
    AkButtonValidation,
    GaLayoutEmptyTab,
    AkButtonAction,
    AkLoader,
    AkAccommodationResume,
    GaListView,
    GaView,
  },
  mixins: [loaderMixin, messageMixin, mainTabMixin, permissionsMixinComputed],
  head() {
    return {
      title: 'accommodation.my_list',
    };
  },

  props: {},
  data() {
    return {
      accommodations: undefined,
      filter: {enabled: true},
      hasPrepublished: false,
      onboardings: [],
      searchQuery: undefined,
    };
  },

  mounted() {
    this.$refs.loader.load();
    let p2 = accommodationService.resume(this.filter);
    p2.then((data) => {
      this.hasPrepublished = data.some((acc) => acc.status === 'PREPUBLISHED');
      this.accommodations = data;
    }).finally(() => {
      this.$refs.loader.hide();
    });
  },
  computed: {
    showSearch() {
      return this.accommodations !== undefined && this.accommodations.length > 8;
    },
    filteredAccommodations() {
      if (this.accommodations === undefined) return [];
      let query = this.normalizeSearch(this.searchQuery);
      if (!query) return this.accommodations;
      return this.accommodations.filter((item) => this.normalizeSearch(item.name).includes(query));
    },
  },
  methods: {
    /* Recherche insensible à la casse et aux accents */
    normalizeSearch(value) {
      if (!value) return '';
      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    onSearch(query) {
      this.searchQuery = query;
    },
    exportAccommodations() {
      this.showTotalLoaderWithAfter(this.$t('export_in_progress'));
      accommodationService.exportAccommodations(this.filter).then((data) => {
        this.hideLoader();
      });
    },
  },
};
</script>

<template>
  <GaView v-show="this.hasAccommodation || !isOwner" :title="$t('accommodation.my_list')">
    <template #action>
      <AkButtonAction secondary :label="$t('payment.download')" little @click="exportAccommodations()" />
    </template>
    <template #content>
      <GaListView
        :search-placeholder="$t('accommodation.search')"
        :searchable="showSearch"
        search-class="md:w-[calc((100%_-_24px)/2)] lg:w-[calc((100%_-_48px)/3)] xl:w-[calc((100%_-_72px)/4)]"
        @search="onSearch">
        <template #content>
          <AkLoader message="Chargement en cours" ref="loader">
            <template #content>
              <div class="md:grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 flex flex-col gap-6">
                <AkAccommodationResume v-for="item of this.filteredAccommodations" :item="item" :key="item.id" />
              </div>
            </template>
          </AkLoader>
        </template>
      </GaListView>
    </template>
  </GaView>
  <ga-layout-empty-tab
    v-if="!this.hasAccommodation && isOwner"
    icon="ga-home"
    title="Mes __logements__"
    gradient="linear-gradient(109.23deg, rgba(63, 180, 229, 0.2) 1.88%, rgba(153, 223, 252, 0) 44.31%), #ECF7FE"
    background-color="#ECF7FE"
    @init="init">
    <div class="flex flex-col grow items-center md:gap-8 gap-4 md:p-4 p-8 pb-0 md:min-w-[45%]">
      <div class="border-[7px] border-jordy-200 rounded-full flex items-center justify-center w-[70px] h-[70px]">
        <i class="ga-icon ga-home text-[30px] text-grey-900" />
      </div>
      <div class="flex flex-col gap-6 items-center">
        <div class="text-base text-grey-900 text-center">
          <div class="font-semibold text-lg">Retrouvez ici votre logement !</div>
          Publiez votre logement sur Guestadom et générez vos premiers revenus !
        </div>
        <AkButtonValidation
          ref="onboardingButton"
          class="btn-primary !h-[48px] w-fit !px-8 font-medium"
          @click="goToOnboarding"
          :label="
            hasPendingOnboarding ? 'Reprendre la création de mon logement' : 'Démarrer la création de mon logement'
          " />
      </div>
    </div>
    <img v-if="$isMobile()" src="@refonte/img/emptyTabs/logement_mobile_illustration.png" alt="" class="w-full" />
    <div v-else class="h-full md:max-w-[55%] w-full flex items-end justify-end">
      <img src="@refonte/img/emptyTabs/logement_illustration.png" alt="" class="h-auto object-cover object-left" />
    </div>
  </ga-layout-empty-tab>
</template>
